import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../../services/search.service';
import { BusquedaInmueble } from '../../models/InmuebleSearch.model.response';
import { InmuebleBusqueda } from '../../models/inmueble.busqueda';
import { DetalleInmuebleService } from '../../services/detalle-inmueble.service';
import { DetalleInmuebleModel } from '../../models/detalle-inmueble.model';
import { Subscription } from 'rxjs';
import { AppConfig } from '../../AppConfig';
 
import { PlatformLocation } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RecomendarInmuebleService } from '../../services/recomendar-inmueble.service';
import { RecomendarInmuebleModel } from '../../models/recomendar-inmueble.model';
import { ValidadoresCazaOportunidadService } from '../../services/validadoresCazaOportunidad.service';
import { NotificacionInmueble } from '../../models/InmuebleSearch.model.response';
import { InmuebleResponse } from '../../models/InmueblesResponse';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
 
 
 
 
@Component({
    selector: 'app-inmuebles',
    templateUrl: './inmuebles.component.html',
    styleUrls: ['./inmuebles.component.css'],
    standalone: false
})
export class InmueblesComponent implements OnInit {
  buscar: any;
  like: boolean = true;
  inmuebles: InmuebleBusqueda[] = [];
  paginador: any;
  detalle: DetalleInmuebleModel;
  mostrar: boolean = false;
  mensajeError: string;
  executed: boolean = false;
  paginaActual: number;
  state: any;
  subscription: Subscription;
  paginas: number[];
  cargandoFicha = false;
  noPaginas: number[] = [];
  listo: boolean = false;
  mensaje: string;
 
  filasSeleccionadas: number = 4;
  paginadorInicializado: boolean = false;
  opcionesFilas: number[] = [];
  desdeFila: number = 0;
  hastaFila: number = 0;
  totalFilas: number = 0;
 
  constructor(private routes: Router,
    private detalleService: DetalleInmuebleService,
    private searchServ: SearchService,
    private activatedRoute: ActivatedRoute,
    private appConfig: AppConfig) {
    this.mensajeError = '';
  }
 
  ngOnInit() {
    this.actualizarAnchoPantalla();
    this.detalle = new DetalleInmuebleModel();
    this.subscription = this.activatedRoute.queryParamMap.subscribe(params => {
      this.paginaActual = +localStorage.getItem('page');
      if (!this.paginaActual) {
        this.paginaActual = 0;
      }
 
      this.buscar = JSON.parse(atob(params.get('buscar')));
      this.obtenerInmuebles(this.buscar, this.paginaActual);
    })
  }
 
  @HostListener('window:resize')
  escuchaRedimensionamientoPantalla(){
    this.actualizarAnchoPantalla();
  }
  cambiarLike(): void {
    this.like = !this.like;
  }
 
  actualizarAnchoPantalla(){
    const ancho = window.innerWidth;
    if(ancho < 1332){
      this.filasSeleccionadas = 1;
    }
  }
  obtenerInmuebles(buscar: BusquedaInmueble, page: number): void {
    this.mensajeError = '';
    this.listo = false;
    const totalReg = this.filasSeleccionadas * 4;
    this.searchServ.obtenerFilasInmuebles(buscar, page, totalReg).subscribe(response => {
      this.paginador = response.respuesta;
      this.inmuebles = response.respuesta.content;
      const totalElements = this.paginador.totalElements;
      this.totalFilas = Math.ceil(totalElements / 4);
      //this.inmuebles = this.inmuebles.filter( inm => inm.precio > 1.0);
      this.initOpcionesFilas();
      this.initPaginador();
      this.listo = true;
      this.mensaje = response.mensaje;
      console.log("respuesta de mensaje " + this.mensaje);
      if (this.inmuebles.length == 0) {
        this.mensajeError = 'No se encontraron resultados.'
      }else{
        this.mensaje = response.mensaje;
      }
    });
  }
 
 
  public obtenerFichaTecnica(folio: string) {
    this.cargandoFicha = true;
    this.detalleService.getFichaTecnica(folio).subscribe(response => {
      saveAs(response.body, response.filename);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Descargado correctamente',
        showConfirmButton: false,
        timer: 1500
      })
      this.cargandoFicha = false;
    });
   
  }
 
  public detalleInmueble(folio: string) {
    localStorage.setItem('page', `${this.paginaActual}`);
    this.routes.navigate(['/detalle', folio]);
  }
 
  public contactarAgente(folio: string) {
    this.detalleService.getDetalleInmueble(folio).subscribe(response => {
      if (response.inmueble) {
        this.setData(response.inmueble);
      }
    })
  }
 
  private setData(data: any): void {
    this.detalle.folio = data.folio;
    this.detalle.emailGerente = data.idPromotor.gerenteEntity.email;
    this.detalle.promotor = data.idPromotor;
    this.detalle.inmueble = data;
  }
 
  public getUrl(): string {
    return this.appConfig.getConfig('base_url');
  }
 
  irPagina(page: number): void {
    this.paginaActual = page;
    localStorage.setItem('page', `${this.paginaActual}`);
    this.obtenerInmuebles(this.buscar, page);
  }
 
  initPaginador(): void {
    const registrosPorFila = 4;
 
    const primerRegistro = this.paginador.number * this.paginador.size + 1;
    const ultimoRegistro = primerRegistro + this.paginador.numberOfElements - 1;
 
    this.desdeFila = Math.ceil(primerRegistro / registrosPorFila);
    this.hastaFila = Math.ceil(ultimoRegistro / registrosPorFila);
  }
 
  initOpcionesFilas(): void {
    this.opcionesFilas = [1, 2, 3, 4];
 
    if (!this.paginadorInicializado) {
      if (!this.opcionesFilas.includes(this.filasSeleccionadas)) {
        this.filasSeleccionadas = 2;
      }
      this.paginadorInicializado = true;
    }
  }
 
  cambiarFilasPorPagina(): void {
    this.paginaActual = 0;
    this.obtenerInmuebles(this.buscar, this.paginaActual);
  }
 
  getFilasInmuebles(): InmuebleBusqueda[][] {
    const filas: InmuebleBusqueda[][] = [];
    for (let i = 0; i < this.inmuebles.length; i += 4) {
      filas.push(this.inmuebles.slice(i, i + 4));
    }
    return filas;
  }
}